import React from 'react';
import { Grid, makeStyles, Typography } from 'housecall-ui';

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    textAlign: 'center',
  },
}));

export const SuccessView = () => {
  const { content } = useStyles();

  return (
    <Grid container className={content}>
      <Grid item xs={12} sm={8}>
        <Typography gutterBottom variant="h5" align="center">
          Thank you
        </Typography>

        <Typography gutterBottom variant="body1" align="center">
          Your booking was successful. We&apos;ll send you an email confirmation.
        </Typography>
      </Grid>
    </Grid>
  );
};
